import React from "react";
import { Link } from "react-router-dom";
import HobbliInfoLayout from "./HobbliInfoLayout";

export default function AboutUs() {
  return (
    <HobbliInfoLayout
      eyebrow="About & Support"
      title="Built for people who love collecting."
      intro="Hobbli is a collector-focused home for organizing collections, discovering items, learning about the hobby, and connecting with other collectors."
    >
      <h2>About Hobbli</h2>
      <p>
        Hobbli started as a small project built by hobby enthusiasts who wanted a more useful,
        welcoming place to collect, research, share, and connect. We are continuing to build it
        around the things collectors actually do: cataloging collections, identifying items,
        exploring checklists and market information, and enjoying the hobby with other people.
      </p>
      <p>
        The platform is still growing, and feedback from collectors helps shape what comes next.
        If you find something that needs attention or have an idea that would make Hobbli better,
        we want to hear it.
      </p>

      <div className="info-card-grid">
        <Link className="info-card" to="/about"><h3>About Hobbli</h3><p>Our story, what we're building, and why Hobbli exists.</p></Link>
        <Link className="info-card" to="/about/faq"><h3>Help & FAQ</h3><p>Quick answers about collections, identification, accounts, and the marketplace.</p></Link>
        <Link className="info-card" to="/about/contact"><h3>Contact & Support</h3><p>Report a bug, send a suggestion, ask a question, or request help.</p></Link>
        <Link className="info-card" to="/about/terms"><h3>Terms & Policies</h3><p>Review the terms that apply when using Hobbli.</p></Link>
      </div>

      <div className="info-callout">
        <h2>Need help or have an idea?</h2>
        <p>Tell us what happened, what you need, or what you think Hobbli should build next.</p>
        <Link className="info-primary-link" to="/about/contact">Contact Hobbli</Link>
      </div>
    </HobbliInfoLayout>
  );
}
